import { render } from "./App.vue?vue&type=template&id=3d10d106"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3d10d106&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.5.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__